import axios from "axios"; // 引入axios
import router from "../router";
import { baseURL2 } from "./url";
// process.env.VUE_APP_BASEURL
// const baseURL = '/cus' //本地开发 跨域

// const baseURL = 'http://192.168.24.128:8183/' //测试服务器
// const baseURL = 'http://43.157.63.49:8187/' //正式环境波斯语预览版本
// const baseURL = process.env.VUE_APP_BASEURL;
// const baseURL = 'shineray-glo-pre.suxiangkj.com/'
const baseURL = baseURL2;
const service = axios.create({
  baseURL: baseURL,
  timeout: 1800000
});
window._axiosPromiseArr = [];
service.interceptors.request.use(
  config => {
    if (config.url === "/manage/staff/login") {
      config.headers = {
        "Content-Type": "application/json",
        ...config.headers
      };
    } else {
      config.headers = {
        "Content-Type": "application/json",
        satoken: sessionStorage.getItem("token"),
        ...config.headers
      };
    }
    config.cancelToken = new axios.CancelToken(cancel => {
      window._axiosPromiseArr.push({ cancel });
    });
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// http response 拦截器
service.interceptors.response.use(
  response => {
    // 下载文件处理文件名
    if (response.headers["content-disposition"]) {
      response.data.fileName = decodeURIComponent(
        response.headers["content-disposition"].split("=")[1]
      );
    }
    // console.log(response.data,'------respond.data')
    if (response.data.status == "A0230") {
      alert("该账号已禁用，将被强制登出");
      router.replace({
        path: "/login"
      });
    }

    if (response.data.status == 0) {
      // console.log(response.data,'------respond.data')
      return response.data;
    } else {
      if (response.message) {
        alert(response.data.message);
      }

      return response.data;
    }
  },
  error => {
    if (!error.response) {
      console.log("检测到请求错误");
      return;
    }
    switch (error.response.status) {
      case 500:
        console.log("500");
        break;
      case 404:
        console.log("404");
        break;
    }

    return error;
  }
);
export default service;
